import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MexGridPageComponent } from "./mex-grid-page/mex-grid-page.component";
import { MexGridTabComponent } from "./mex-grid-tab/mex-grid-tab.component";
import { Routes, RouterModule } from "@angular/router";
import { SharedModule } from "../shared/shared.module";

import { RightPanelModule } from "../right-panel/right-panel.module";
import { IconsModule } from "@va/core-library/icons";
import { MexGridTableComponent } from "./mex-grid-table/mex-grid-table.component";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { CustomConsensusModule } from "../custom-consensus/custom-consensus.module";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ResearchInsightPopupComponent } from "./research-insight-popup/research-insight-popup.component";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzDrawerModule } from "ng-zorro-antd/drawer";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzAnchorModule } from "ng-zorro-antd/anchor";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzTypographyModule } from "ng-zorro-antd/typography";
import { NzSpinModule } from "ng-zorro-antd/spin";

/*
Mex Routes:
/mex/:ticker/:cut/:tab
/mex/:ticker/:cut/:tab/:source


Constant format - insights.va.com/mex/<ticker>/<cut>/<tab>/:<source>
new - insights.va.com/mex/AAL/NMV/IS
new - insights.va.com/mex/AAL/SAR/IS/BAML


Page Title:
Model Explorer <ticker> #<cut>
*/
const mexGridRoutes: Routes = [
  {
    path: ":ticker/:cut/:tab",
    component: MexGridPageComponent,
  },
  {
    path: ":ticker/:cut/:tab/:source",
    component: MexGridPageComponent,
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(mexGridRoutes)],
  exports: [RouterModule],
})
export class MexGridRoutingModule {}

@NgModule({
  declarations: [
    MexGridPageComponent,
    MexGridTabComponent,
    MexGridTableComponent,
    ResearchInsightPopupComponent,
  ],
  imports: [
    CommonModule,
    MexGridRoutingModule,
    SharedModule,
    NzLayoutModule,
    NzDrawerModule,
    NzTabsModule,
    NzAnchorModule,
    NzPopoverModule,
    NzSkeletonModule,
    RightPanelModule,
    IconsModule,
    ChartPlotterModule,
    CustomConsensusModule,
    InfiniteScrollModule,
    CurrencySelectModule,
    NzToolTipModule,
    NzTypographyModule,
    NzSpinModule,
  ],
  exports: [ResearchInsightPopupComponent],
})
export class MexGridPageModule {}
